// extracted by mini-css-extract-plugin
export default {"hr":"HrWithIcon_hr__aINzd","hrWrap":"HrWithIcon_hrWrap__7vPpx","iconWrap":"HrWithIcon_iconWrap__elck4"};